(function () {
  'use strict';
  const source = document.currentScript;
  if (!source) return;
  const urls = [source.dataset.libraries, source.dataset.theme, source.dataset.custom].filter(Boolean);
  let started = false;
  function start() {
    if (started) return;
    started = true;
    urls.forEach(url => {
      const script = document.createElement('script');
      // Classic scripts with async=false retain insertion order, including cached files.
      script.async = false;
      script.src = url;
      document.head.appendChild(script);
    });
  }
  // Let the browser paint the server-rendered page before animation feature tests
  // and section initialization force layout. Background tabs must initialize too.
  if (document.hidden) start();
  else requestAnimationFrame(() => setTimeout(start, 0));
}());
